import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router =new Router ({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/dashboard/login'),
      // meta: {notRequireAuth: true}
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Pages
        {
          name: 'User Profile',
          path: 'pages/user',
          component: () => import('@/views/dashboard/pages/UserProfile'),
        },
        {
          name: 'Serial Number',
          path: 'Aktivasi',
          component: () => import('@/views/dashboard/Aktivasi.vue'),
        },
        {
          name: 'Kas Masuk',
          path: 'pemasukan',
          component: () => import('@/views/dashboard/pemasukan.vue'),
        },
        {
          name: 'Kas Keluar',
          path: 'Pengeluaran',
          component: () => import('@/views/dashboard/pengeluaran.vue'),
        },
        {
          name: 'Notifications',
          path: 'components/notifications',
          component: () => import('@/views/dashboard/component/Notifications'),
        },
        {
          name: 'Icons',
          path: 'components/icons',
          component: () => import('@/views/dashboard/component/Icons'),
        },
        {
          name: 'Typography',
          path: 'components/typography',
          component: () => import('@/views/dashboard/component/Typography'),
        },
        // Tables
        

        {
          name: 'Regular Tables',
          path: 'tables/regular-tables',
          component: () => import('@/views/dashboard/tables/RegularTables'),
        },
        // Maps
        {
          name: 'Google Maps',
          path: 'maps/google-maps',
          component: () => import('@/views/dashboard/maps/GoogleMaps'),
        },
        // Upgrade
        {
          name: 'Upgrade',
          path: 'upgrade',
          component: () => import('@/views/dashboard/Upgrade'),
        },
      ],
    },
  ],
})
// router.beforeEach((to, from, next) => {
  

//   const tokenExist = localStorage.getItem('user')
//   const statususer = localStorage.getItem('statususer')
//   if (to.path === '/login' && tokenExist && statususer) {
//     console.log('ke halama dasboard')
//     next('/')
//   }


//   if (!tokenExist && !statususer) {
//     console.log('ke halama ini')
//     //this.router.replace('/');
//      next('/login') ;
//   }
    
//   else {
//   console.log('ke halama login')
//     next('/login')
//   }
// })
export default router